export const getters = {
  tableQrList: ({ tableQrList }) => tableQrList,
  tableNumberList: ({ tableQrList }) => tableQrList.map((each) => each.number)
};
